import { QueryClient } from "@tanstack/react-query";

/**
 * Module-scope QueryClient instance (design.md D3). Instantiated once so it
 * is importable from tests and never recreated on re-render.
 *
 * Defaults are intentionally conservative: Moodle WS is slow, and an
 * unauthenticated-refetch-on-focus would be a surprise regression on every
 * existing screen once react-query adoption spreads beyond duels. Polling
 * is opt-in per query (e.g. `refetchInterval` on the pending-duels query),
 * never a client-wide default.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
